import { createFileRoute } from '@tanstack/react-router';

import { PortalRenewPage } from '@/modules/portal/pages/PortalRenewPage';

export const Route = createFileRoute('/account/renew/')({
  component: PortalRenewPage,
});
